import { Component, type ErrorInfo, type ReactNode } from "react";
import { ErrorState } from "@/components/ui/error-state";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

/**
 * Legfelső hibahatár: ha egy oldal renderelés közben hibára fut (tipikusan egy telepítés
 * után már nem létező, külön töltődő chunk), üres fehér lap helyett rövid üzenetet és
 * újratöltés gombot mutatunk. Osztály-komponens: hibahatárnak a Reactban nincs hook-os párja.
 */
export class AppErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Váratlan hiba az alkalmazásban:", error, info.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="flex min-h-screen flex-col items-center justify-center p-6">
        <ErrorState
          title="Hiba történt az oldal betöltésekor"
          description="Lehet, hogy időközben frissült az alkalmazás. Az újratöltés általában megoldja."
        />
      </div>
    );
  }
}
